<template>
	<TableView :col="columns" :getData="getData"/>           
</template>
<script>
import common from '@/assets/js/common.js';
export default {
  components: {
    TableView : () => import('@/components/Common/DataTable/Table') ,
  },
  mixins: [common],
  props: ['report_date', 'account_numbers'],
  data(){
  	return {
      columns: (() => {
        const cols = [
          { title: 'Accoun No.', field: 'account_number', label: 'User ID', sortable: true, visible: 'true', tdStyle: {padding: "0.8rem !important"}},
          /* { title: 'Live Cash BAL', field: 'report', nested: 'live_cash_balance', tdComp: 'Number', 'floatLength': 2,}, */
          { title: 'TD Closing BAL', field: 'report', nested: 'td_closing_cash_balance', tdComp: 'Number', 'floatLength': 2,},
          { title: 'SD Closing BAL', field: 'report', nested: 'sd_closing_cash_balance', tdComp: 'Number', 'floatLength': 2,},
          { title: 'MARKET VALUE', field: 'report', nested: 'market_value', tdComp: 'Number', 'floatLength': 2},
          { title: 'TOTAL EQUITY', field: 'report', nested: 'total_equity' , tdComp: 'Number', 'floatLength': 2},
          { title: 'MARGIN USED', field: 'report',nested: 'margin_used' , tdComp: 'Number', 'floatLength': 2},
          { title: 'MARGIN (EXCESS/DEFICIT)', field: 'report', nested: 'margin_available', tdComp: 'Number', 'floatLength': 2 },
          /* { title: 'Action', field: '', thClass: 'text-center' }, */
        ]
        const groupsDef = {
          Normal: [],
          Sortable: [],
          Extra: ['Operation']
        }
        return cols.map(col => {
          Object.keys(groupsDef).forEach(groupName => {
            if (groupsDef[groupName].includes(col.title)) {
              col.group = groupName
            }
          })
          return col
        })
      })(),
  	}
  },
  created() {
  },
  methods: {
    async getData(query, filter) {
      if(this.account_numbers != null){
        var { limit = 100, offset = 0, sort = '', order = '' } = JSON.parse(JSON.stringify(query));
        //sort = sort||"last_trade_date";
        //filter['has_trade'] = 1;
        filter['approved_at'] = {from_date:'2000-01-01'};
        this.columns.forEach(col => {
          if (query[col.field]) {
            filter[col.field] = query[col.field];
          }else if(typeof filter[col.field] != 'undefined'){
            delete filter[col.field];
          }
        });
        if(this.account_numbers.filter(val => val == 'ALL').length == 0)
          filter['account_number']  = this.account_numbers.join(',');
        let uri = 'customer_list?limit='+limit+'&offset='+offset+'&sort='+sort+'&order='+order+'&filter='+JSON.stringify(filter)+'&report=1'+'&report_date='+this.report_date[1];
        return await this.call_axios(uri);
      }
      this.$toasted.error("Please select atleast one account number.",{duration:1000});
      return {response: {data: {result: []}}}
    }
  }
}
</script>
<style>
.header-bar{
  text-align: center;
  vertical-align: middle !important;
  font-weight: 700;
  color:#fff;
  padding: 10px 0 0 0;
}
</style>